import {
  DIALOG_TYPE,
  MOUNT,
  UNMOUNT,
  UPDATE_ACTIVE_DIALOG,
} from './constants'

const mount = () => ({ type: MOUNT })
const unmount = () => ({ type: UNMOUNT })
const setActiveDialog = () => ({ type: UPDATE_ACTIVE_DIALOG, active: true, value: DIALOG_TYPE.CREATE })
const setInactiveDialog = () => ({ type: UPDATE_ACTIVE_DIALOG, active: false, value: DIALOG_TYPE.CREATE })
const setActiveSiteDialog = () => ({ type: UPDATE_ACTIVE_DIALOG, active: true, value: DIALOG_TYPE.UPDATE })
const setInactiveSiteDialog = () => ({ type: UPDATE_ACTIVE_DIALOG, active: false, value: DIALOG_TYPE.UPDATE })

export {
  mount,
  unmount,
  setActiveDialog,
  setInactiveDialog,
  setActiveSiteDialog,
  setInactiveSiteDialog,
}
